module.exports = "img/flags/DJ.9fdcbac.png";